__turbopack_context__.v({
  "modalImage": "styles-module__YZbZXq__modalImage",
  "relatedSlide": "styles-module__YZbZXq__relatedSlide",
});
